import { BMButton, BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";

import { ERROR_IMAGE_BASE64 } from "../../../assets/error";
import { ErrorSectionItemSmallProps } from "./types";

import BMView from "../../View/BMView";

export default function ErrorSectionSmall({
  title,
  caption,
  button,
  style,
  image,
}: ErrorSectionItemSmallProps) {
  return (
    <BMView
      flex
      align="center"
      justify="center"
      style={[styles.wrapper, style]}
    >
      <BMView align="center" spacing="lg" style={styles.container}>
        <BMView spacing="sm">
          <BMView row align="center" spacing="md">
            <Image
              style={styles.image}
              source={{ uri: image?.link ?? ERROR_IMAGE_BASE64 }}
              alt={image?.altText}
            />
            <BMText
              variant="uiLarge"
              ink="BMStyleTextInkPrimary"
              numberOfLines={2}
              lineBreakMode="tail"
            >
              {title || "Something went wrong"}
            </BMText>
          </BMView>
          <BMView flex>
            <BMText
              variant="paragraphSmall"
              ink="BMStyleTextInkSecondary"
              numberOfLines={2}
              lineBreakMode="tail"
            >
              {caption ||
                "Sorry, our system encounters a bit of trouble. Please check again later."}
            </BMText>
          </BMView>
        </BMView>
        {button ? (
          Array.isArray(button) ? (
            <BMView row spacing="xs" style={styles.width100}>
              {button.map((btn, index) => {
                if (!btn) return <BMView key={index} flex />;
                return (
                  <BMView key={index} flex>
                    <BMButton
                      label={btn.label}
                      role={btn.type || "PRIMARY"}
                      size="NORMAL"
                      stretchable
                      onPress={btn.onPress}
                    />
                  </BMView>
                );
              })}
            </BMView>
          ) : (
            <BMView style={styles.width50}>
              <BMButton
                loading={button.loading}
                label={button.label}
                role={button.type || "PRIMARY"}
                size="NORMAL"
                stretchable
                onPress={button.onPress}
              />
            </BMView>
          )
        ) : null}
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    minWidth: 350,
  },
  container: {
    marginTop: BMPrimitives.BMSize.md,
    marginBottom: BMPrimitives.BMSize.xl2,
    marginHorizontal: BMPrimitives.BMSize.md,
  },
  image: {
    width: 48,
    height: 48,
  },
  width50: {
    width: "50%",
  },
  width100: {
    width: "100%",
  },
});
